"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState, useEffect, useContext } from "react";
import { ApiNotificationCause } from "@/generated/models/ApiNotificationCause";
import { usePrefetchNotifications } from "@/hooks/useNotificationsQuery";
import { AuthContext } from "@/components/auth/Auth";
export interface NotificationFilter {
  cause: ApiNotificationCause[];
  title: string;
}
const NotificationFilters: NotificationFilter[] = [{
  cause: [],
  title: "All"
}, {
  cause: [ApiNotificationCause.IdentityMentioned, ApiNotificationCause.DropQuoted],
  title: "Mentions"
}, {
  cause: [ApiNotificationCause.DropReplied],
  title: "Replies"
}, {
  cause: [ApiNotificationCause.IdentitySubscribed],
  title: "Follows"
}, {
  cause: [ApiNotificationCause.DropVoted, ApiNotificationCause.DropReacted],
  title: "Reactions"
}, {
  cause: [ApiNotificationCause.WaveCreated],
  title: "Invites"
}];
export default function NotificationsCauseFilter(t0) {
  const $ = _c(17);
  const {
    activeFilter,
    setActiveFilter
  } = t0;
  const [activeFilterIndex, setActiveFilterIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      left: 0,
      width: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [highlightStyle, setHighlightStyle] = useState(t1);
  const containerRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttonRefs = useRef(t2);
  const {
    connectedProfile
  } = useContext(AuthContext);
  const prefetchNotifications = usePrefetchNotifications();
  let t3;
  if ($[2] !== connectedProfile || $[3] !== prefetchNotifications) {
    t3 = filter => {
      if (!connectedProfile) {
        return;
      }
      prefetchNotifications({
        identity: connectedProfile.handle,
        cause: filter.cause,
        pages: 1
      });
    };
    $[2] = connectedProfile;
    $[3] = prefetchNotifications;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleHover = t3;
  let t4;
  let t5;
  if ($[5] !== activeFilterIndex) {
    t4 = () => {
      const button = buttonRefs.current[activeFilterIndex];
      if (button) {
        let l = button.offsetLeft;
        let w = button.offsetWidth;
        if (activeFilterIndex === 0) {
          l = l + 2;
          w = w - 2;
        }
        if (activeFilterIndex === NotificationFilters.length - 1) {
          w = w - 2;
        }
        setHighlightStyle({
          left: l,
          width: w
        });
      }
    };
    t5 = [activeFilterIndex];
    $[5] = activeFilterIndex;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  const handleChange = (filter_0, filterIndex) => {
    setActiveFilter(filter_0);
    setActiveFilterIndex(filterIndex);
    const button_0 = buttonRefs.current[filterIndex];
    const container = containerRef.current;
    if (button_0 && container) {
      const containerWidth = container.clientWidth;
      const scrollWidth = container.scrollWidth;
      const buttonLeft = button_0.offsetLeft;
      const buttonWidth = button_0.offsetWidth;
      let scrollLeft = buttonLeft - containerWidth / 2 + buttonWidth / 2;
      if (scrollLeft < 0) {
        scrollLeft = 0;
      }
      if (scrollLeft > scrollWidth - containerWidth) {
        scrollLeft = scrollWidth - containerWidth;
      }
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth"
      });
    }
  };
  let t6;
  if ($[8] !== activeFilter) {
    t6 = filter_1 => activeFilter === filter_1;
    $[8] = activeFilter;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const isActive = t6;
  const t7 = "tw-w-full tw-pt-2 tw-pb-2 lg:tw-pt-4";
  const t8 = "tw-relative tw-flex tw-nowrap tw-items-center tw-gap-1 tw-h-10 tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-800 tw-rounded-lg tw-overflow-x-auto";
  let t9;
  if ($[10] !== highlightStyle.left || $[11] !== highlightStyle.width) {
    t9 = <div className="tw-absolute tw-h-8 tw-bg-iron-800 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-in-out" style={{
      left: highlightStyle.left,
      width: highlightStyle.width
    }} />;
    $[10] = highlightStyle.left;
    $[11] = highlightStyle.width;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = NotificationFilters.map((filter_2, index) => <NotificationCauseFilterButton key={`notification-cause-filter-${filter_2.cause ?? "ALL"}`} title={filter_2.title} isActive={isActive(filter_2)} onClick={() => handleChange(filter_2, index)} onMouseEnter={() => handleHover(filter_2)} buttonRef={el => buttonRefs.current[index] = el} />);
  let t11;
  if ($[13] !== containerRef || $[14] !== t10 || $[15] !== t9) {
    t11 = <div className={t7}><div ref={containerRef} className={t8}>{t9}{t10}</div></div>;
    $[13] = containerRef;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function NotificationCauseFilterButton(t0) {
  const $ = _c(10);
  const {
    title,
    isActive,
    onClick,
    onMouseEnter,
    buttonRef
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = () => `tw-border-none tw-bg-transparent tw-no-underline tw-flex tw-justify-center tw-items-center
     tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-8 tw-rounded-lg tw-transition-colors tw-duration-300
     tw-ease-in-out tw-relative z-10 ${isActive ? "tw-text-iron-300" : "tw-text-iron-400 desktop-hover:hover:tw-text-iron-300"}`;
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getLinkClasses = t1;
  const t2 = getLinkClasses();
  let t3;
  if ($[2] !== title) {
    t3 = <span className="tw-font-semibold tw-text-sm">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buttonRef || $[5] !== onClick || $[6] !== onMouseEnter || $[7] !== t2 || $[8] !== t3) {
    t4 = <button className={t2} onClick={onClick} onMouseEnter={onMouseEnter} ref={buttonRef}>{t3}</button>;
    $[4] = buttonRef;
    $[5] = onClick;
    $[6] = onMouseEnter;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}